<template>

    <b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; padding-left: 20px; height:80%; margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:1; padding: 10px 0 10px 0;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray, getProjectPeriodByHistory, getHistoryGroupByStatus} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ProjectProductivityGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history);
        this.projectUserData = this.dashboardData.projectUser;

        if(this.historyData.length <= 0 || this.projectUserData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd ] = getProjectPeriodByHistory(this.historyData);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            thereIsNoData: false,
            loading:false,
            startDate :'',
            endDate : '',
            historyData: '',
            projectUserData: '',
            columnNames: [],
            series: [],
            interval: 7,
            dateRange : [],
            chartOptions: {
                chart: {
                    // height:'80%',
                    type: "line",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#907ED8', '#1BD4D4', '#142459', '#FF5733'],
                markers: {
                    size: this.isFlexible ? 3 : 0,
                    strokeWidth: 1,
                },
                dataLabels: {
                    enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    enabledOnSeries: [0,1,2],
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#fff'], // 데이터 라벨의 색상을 지정합니다.
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -10, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#2E2E38',
                        padding: 5,
                        borderRadius: 7,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 1,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                stroke: {
                    width: [4, 4, 4, 4],
                    curve: 'straight',
                    lineCap: 'butt',
                    width: [3, 2, 2],
                    dashArray: [0, 0, 0, 4],
                },
                xaxis: {
                    categories: [],
                    show:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    }
                },
                yaxis: [
                    {   
                        seriesName: '생산성 (생산량/투입 인력 수)',
                        show: this.isFlexible,
                        labels: {
                            show:this.isFlexible
                        },
                        axisBorder: {
                            show: this.isFlexible,
                        },
                        title:{
                                text: "생산성 (생산량/투입 인력 수)",
                                rotate: 0,
                                offsetX: 80,
                                offsetY: this.offsetYValue,
                               style: { color: '#907ED8' }
                            }
                    },
                    {   
                        seriesName: '투입 인력 수',
                        show: this.isFlexible,
                        labels: {
                            show:this.isFlexible
                        },
                        opposite: true,
                        title:{
                            show: this.isFlexible,
                            text: "투입 인력 수",
                            rotate: 0,
                            offsetX: -10,
                            offsetY: this.offsetYValue,
                            style: { color: '#1BD4D4' }
                        }
                    },
                    {   
                        seriesName: '생산량',
                        show: this.isFlexible,
                        labels: {
                            show:this.isFlexible
                        },
                        axisBorder: {
                            show: this.isFlexible,
                        },
                        opposite: true,
                        title:{
                            show: this.isFlexible,
                            text: "생산량",
                            rotate: 0,
                            offsetX: -30,
                            offsetY: this.offsetYValue,
                            style: { color: '#142459' }
                        }
                    },
                    {
                        seriesName: '평균 생산성',
                        labels: {
                            show: false
                        },
                        opposite: true,
                    },
                ],
                legend: {
                    show: false,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid : {
                    show:false
                }
                
            },
            tableData: [],
        }
    },
    methods: {
        getLabelDateArray() {

            // 프로젝트 정보의 startDate, endDate가 없을 때
            // 데이터의 label 정보로 초기화
            let from = this.startDate;
            let to = this.endDate;
            
            //여기서 eow를 사용하지 않아서 null 처리
            //graphUtils 에서 null로 받으면 프로젝트 첫 시작을로 처리하는 로직 있음
            let eow = null;
            let interval = 7;
            
            // Flexible Graph일 때 filters 값이 우선순위
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }

                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                }
            }

            let labelDateArray = generateLabelDateArray(from, to, null, interval, eow);

            return labelDateArray;
        },

        countData(labelDateArray, historyArray) {

            const arraySize = labelDateArray.length;

            let from = this.startDate;
            let to = this.endDate;

            let countObj = [
                {
                    name: '생산성 (생산량/투입 인력 수)',
                    type: 'area',
                    data: new Array(arraySize).fill(0),
                },
                {
                    name: '투입 인력 수',
                    type: 'line',
                    data: new Array(arraySize).fill(0),
                    dashArray: 1
                },
                {
                    name: '생산량',
                    type: 'line',
                    data: new Array(arraySize).fill(0),
                },
                {
                    name: '평균 생산성',
                    type: 'line',
                    data: new Array(arraySize).fill(0),
                }
            ]

            let index = 0;
            let interval = 7;
            if (this.isFlexible) {
                interval = this.filters.interval != '' ? this.filters.interval : interval;
            }

            interval = Number(interval);

            let productivityTotal = 0; // 누적 productivity

            for (let labelDate of labelDateArray) {

                // labelDate에서 interval 까지의 시간으로 카운트
                let startDate = new Date(labelDate);
                let endDate = new Date(startDate);

                endDate.setDate(endDate.getDate() + interval);

                let output = 0;
                let input = 0;

                historyArray.forEach(item => {
                    let actualDate = new Date(item.maxUpdatedDate);

                    if (item.status == 'DONE' && (startDate <= actualDate && actualDate < endDate)) {
                        output++;
                    }
                });

                this.projectUserData.forEach(item => {
                    // roleIn, roleOut이 없으면 프로젝트의 시작, 종료 or 히스토리 시작, 종료 날짜로 초기화
                    let roleIn = item.roleIn == '' ? from : item.roleIn;
                    let roleOut = item.roleOut == '' ? to : item.roleOut;

                    roleIn = new Date(roleIn);
                    roleOut = new Date(roleOut);

                    if (startDate >= roleIn && endDate < roleOut) {
                        input++;
                    }
                })

                let productivity = output > 0 && input > 0 ? output / input : 0;
                productivityTotal += productivity; // 누적 productivity

                
                countObj[0]['data'][index] = Math.round(productivity * 10) / 10;
                countObj[1]['data'][index] = input;
                countObj[2]['data'][index] = output;
                index++;
            }

            let productivityAverage = Math.floor((productivityTotal / labelDateArray.length) * 10) / 10;

            // '평균 생산성' 데이터 배열에 평균 값을 설정합니다.
            countObj[3]['data'] = new Array(arraySize).fill(productivityAverage);

            // 모든 데이터 포인트에 대해 평균 productivity 값을 설정합니다.
            return countObj;
        },

        visualizeGraph() {

            let dataArray = this.historyData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {
                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }   


            let labelDateArray = this.getLabelDateArray();
            
            let countObj = this.countData(labelDateArray, dataArray);
        
            this.series = countObj;
            this.label = labelDateArray;

            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    xaxis: {
                        categories: this.label,
                    },
                    // yaxis:[
                    //     {
                    //         title:{
                    //             text: "생산성 (생산량/투입 인력 수)",
                    //             rotate: 0,
                    //             offsetX: 80,
                    //             offsetY: this.offsetYValue,
                    //             style: { color: '#907ED8' }
                    //         }
                    //     },
                    //     {
                    //         title:{
                    //         text: "투입 인력 수",
                    //         rotate: 0,
                    //         offsetX: -20,
                    //         offsetY: this.offsetYValue,
                    //         style: { color: '#1BD4D4' }
                    //         }
                    //     },
                    //     {
                    //         title:{
                    //         text: "생산량",
                    //         rotate: 0,
                    //         offsetX: -20,
                    //         offsetY: this.offsetYValue,
                    //         style: { color: '#142459' }
                    //         }
                    //     },
                    //     {
                    //         title:{
                    //             text: "평균 생산성",
                    //             rotate: 0,
                    //             offsetX: 300,
                    //             offsetY: this.offsetYValue,
                    //             style: { color: '#FF5733' }
                    //         }
                    //     },
                    // ]
                });
            }
        },
        setTable() {
            this.tableData = this.data.table;

        }
    },
}
</script>
